// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sp-wrapper[data-v-f22c138a]{padding:12px 0;border-bottom:1px dashed #7e8299}", ""]);
// Exports
module.exports = exports;
